import moment from "moment";

export const colTypeMap = new Map([
  ["USER-DEFINED", "text"],
  ["text", "text"],
  ["varchar", "text"],
  ["numeric", "number"],
  ["float8", "number"],
  ["int4", "number"],
  ["int8", "number"],
  ["timestamp with time zone", "date"],
  ["date", "date"],
  ["timestamp", "date"],
  ["time", "date"],
  ["boolean", "bool"],
  ["bool", "bool"]
]);
const dateFormat = "YYYY-MM-DD";
export const isADate = str => moment(str, dateFormat, true).isValid();
export const formatDate = str => moment(str).format(dateFormat);

const countVowels = str =>
  ["a", "e", "i", "o", "u", "y"]
    .map(v => str.split(v).length - 1)
    .reduce((sum, ele) => sum + ele);

// this catches most acronyms. One exception is No (number), turns into NO
export const toTitleCase = str =>
  str.replace(/\w\S*/g, txt => {
    const vowelCount = countVowels(txt);
    if (txt.length < 3 || !vowelCount || vowelCount === txt.length)
      return txt.toUpperCase();
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });

export const numberWithCommas = x =>
  x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

// set preferred column order for the preview grid

export const defaultChipFilters = [
  { field: "work_area", dropdown: true },
  { field: "survey", dropdown: true },
  { field: "site_id", dropdown: true },
  { field: "project", dropdown: true },
  { field: "hakai_id", dropdown: false },
  // some output views use "hakai_id" and some use "hakai_sample_id"
  { field: "hakai_sample_id", dropdown: false },
  { field: "organization", dropdown: true }
];

// since date is not a chip input we have to add it to have the preview grid display by default
const getColumnOrder = () => [
  "date",
  ...defaultChipFilters.map(filter => filter.field),
  "hakai_sample_id"
];
export const columnOrder = getColumnOrder();

export const selectCategoryStyle = {
  color: "black",
  fontWeight: "bolder",
  margin: -5
};
